<template>
    <b-form class="step-form" @submit.stop.prevent="onSave">
        <div v-if="!showPageLoader" class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div
                        v-for="(field, index) in fields"
                        :key="index"
                        :class="{
                            [field.class]: true,
                            'col-lg-12': field.type == 'heading',
                            'col-md-4':
                                field.type !== 'heading' && !field.class,

                            'col-md-6': field.column == 6,
                            'col-md-8': field.column == 8,
                            'col-md-12': field.column == 12,
                        }"
                    >
                        <div
                            v-if="field.type == 'heading' && index > 0"
                            class="form-border"
                        ></div>

                        <component
                            :is="field.type"
                            :field="field"
                            :data-segment-id="dataSegmentId"
                        ></component>
                    </div>
                    <div class="col-lg-12"><div class="form-border"></div></div>
                </div>
                <!-- <b-button
                    size="sm"
                    variant="secondary"
                    class="mr-3"
                    @click="onBack"
                >
                    Back
                </b-button> -->
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    btn-label="Save"
                    class="mr-3"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                ></base-button>
                <span v-if="loading" class="secondary-color">
                    Please wait. We're processing your request...</span
                >
            </div>
            <div class="col-lg-4"></div>
            <b-modal
                ref="otpmodal"
                size="sm"
                title=""
                hide-footer
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
            >
                <otp-modal
                    v-if="is_data_fetched"
                    :data="otpData"
                    @verificationStatus="otpResponse"
                    @reSendOTP="reSendOTP"
                ></otp-modal>
            </b-modal>
        </div>
        <!-- When data is loading -->
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import request from '@/utils/request'

import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import TextArea from '@/components/registration/TextArea.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import List from '@/components/registration/List.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/registration/IdentityDocumentExpiry.vue'
import Country from '@/components/registration/Country.vue'
import Nationality from '@/components/registration/Nationality.vue'
import TaxId from '@/components/registration/TaxId.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'
import OtpModal from '@/components/registration/OtpModal.vue'
import Dividend from '@/components/registration/Dividend.vue'
import States from '@/components/registration/States.vue'
import Cities from '@/components/registration/Cities.vue'
import IbanNumber from '@/components/registration/IbanNumber.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Country,
        Nationality,
        TaxId,
        WorkType,
        Industry,
        OtpModal,
        Dividend,
        States,
        Cities,
        IbanNumber
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |------------------------------------------------------------re--------------
    */
    data() {
        return {
            section: 'kyc',
            fields: [],
            showPageLoader: true,
            otpData: null,
            is_data_fetched: false,
             w9FormFields: [],
            indexes: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            restrictDuplicateCustomers: (state) =>
                state.registration.restrictDuplicateCustomers,
        }),

        ...mapGetters(['loading', 'dataSegmentId']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        window.fbq('track', 'PageView')
        this.$store.dispatch('trackEvent', {event: "JS | SSA Register KYC"});
        this.getRecords()
        let form = this.$store.state.registration.form

        if (!form.fatcaInfo.CNICNumber && form.identityInfo.number ) {
            this.$store.commit('updateField', {
                key: 'fatcaInfo.CNICNumber',
                value: form.identityInfo.number.replace(/-/g, ''),
            })
        }
        if (form.basicInfo.firstName) {
            this.$store.commit('updateField', {
                key: 'fatcaInfo.titleOfAcc',
                value: form.basicInfo.firstName,
            })
        }

        let placeofbirth = form.basicInfo.placeOfBirth
        if (placeofbirth) {
            this.$store.commit('updateField', {
                key: 'fatcaInfo.placeOfBirth',
                value: placeofbirth,
            })
        }
        
    }, // End of Component > computed

    created() {
        this.$store.watch(
            (state) => {
                return this.registrationW9WatchKey(this.$store.state.registration.form)
            },
            () => {
                this.hideW9Form()
            }
        )
        this.$store.watch(
            (state) => {
                return this.registrationCRSWatchKey(this.$store.state.registration.form)
            },
            () => {
                this.hideCRSForm()
            }
        )
    },

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            //.$router.push('/register-customer/finish')
            //validate the form fields
            var str = this.$store.getters.getField('fatcaInfo.CNICNumber')
            if (str) {
                var newStr = str.replace(/-/g, '')
                this.$store.commit('updateField', {
                    key: 'fatcaInfo.CNICNumber',
                    value: newStr,
                })
            }

            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                this.$store.commit('updateField', {
                    key: 'ssaForms.form3.valid',
                    value: true,
                })
                // this.$store.commit('setLoading', true)

                // this.sendOPT()

                // this.$store.commit('setLoading', false)
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-investment-ssa',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push('/ssa-customer/investment')
                }
            } else {
                this.$store.commit('updateField', {
                    key: 'ssaForms.form3.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        disableFatcaCnicAndTitleFields() {
            if (!this.fields || !this.fields.length) {
                return
            }
            this.fields.forEach((field) => {
                if (
                    field.key === 'fatcaInfo.CNICNumber' ||
                    field.key === 'fatcaInfo.titleOfAcc' ||
                    field.key === 'fatcaInfo.placeOfBirth'
                ) {
                    this.$set(field, 'isDisabled', true)
                }
            })
        },

        /**
         * get the form fields when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        section: this.section,
                    },
                })
                let languageOption =
                    this.$store.state.registration.form.languageOption

                if (languageOption == 'urd') {
                    for (var i = 0; i < data.data.length; i++) {
                        data.data[i].label = data.data[i].urduLabel
                    }
                }
                this.showPageLoader = false
                this.fields = data.data
                // console.log("fieldss ", this.fields)
                this.hideCRSForm()
                this.hideW9Form()
                this.applyCountryOfResidenceFromSetupProfileToKyc()
                this.disableFatcaCnicAndTitleFields()
            } catch (error) {
                // console.log('KYC error: ' + error)
            }
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method
        showW9Form() {
            if (this.w9FormFields.length) {
                for (var i = 0; i < this.w9FormFields.length; i++) {
                    this.fields.push(this.w9FormFields[i])
                }
                this.w9FormFields = []
            }
        },
        hideW9Form() {

            let usCitizen =
                this.$store.state.registration.form.fatcaInfo.isUSCitizen || 'No'
            let usResident =
                this.$store.state.registration.form.fatcaInfo.isUSResident || 'No'
            let usGreenCard =
                this.$store.state.registration.form.fatcaInfo.greenCardUS || 'No'
            let countryOfResidence =
                this.$store.state.registration.form.basicInfo.countryOfResidence || ''
            let nationality =
                this.$store.state.registration.form.basicInfo.nationality || ''
            let CountryResidentTitle =
                this.$store.state.registration.form.fatcaInfo.CountryResidentTitle || ''
            let CountryTaxTitle =
                this.$store.state.registration.form.fatcaInfo.CountryTaxTitle || ''
            let dualNationalCountryTitle =
                this.$store.state.registration.form.fatcaInfo.dualNationalCountryTitle || ''
            if (
                usCitizen == 'No' && 
                nationality != 'United States of America' &&
                countryOfResidence != 'United States of America' &&
                usResident == 'No' &&
                usGreenCard == 'No' &&
                CountryResidentTitle != 'United States of America' &&
                CountryTaxTitle != 'United States of America' &&
                dualNationalCountryTitle != 'United States of America' 
            ) {
                let idx = this.fields.reduce((a, field, index) => {
                    if (
                        field.label == 'W-9 Form (For US Citizens/Residents)' ||
                        field.key == 'w9Info.fullName' ||
                        field.key == 'w9Info.businessName' ||
                        field.key == 'w9Info.federalTax' ||
                        field.key == 'w9Info.payeeCode' ||
                        field.key == 'w9Info.fatcaCode' ||
                        field.key == 'w9Info.address' ||
                        field.key == 'w9Info.cityId' ||
                        field.key == 'w9Info.stateId' ||
                        field.key == 'w9Info.zipCode' ||
                        field.key == 'w9Info.accountNumber' ||
                        field.key == 'w9Info.tin' ||
                        field.key == 'w9Info.city' ||
                        field.key == 'w9Info.ssn'
                    )
                    a.push(index)
                    return a
                }, [])
                this.w9FormFields = []
                for (var i = 0; i < idx.length; i++) {
                    this.w9FormFields.push(this.fields[idx[i]])
                }

                this.fields.splice(idx[0], idx.length)
               
            } else {
                this.showW9Form()
            }
        },
        showCRSForm(){
            if (this.CRSFormFields.length) {
                for (var i = 0; i < this.CRSFormFields.length; i++) {
                    this.fields.push(this.CRSFormFields[i])
                }
                this.CRSFormFields=[]
            }
        },
        hideCRSForm(){
             let countryOfResidence =
                this.$store.state.registration.form.basicInfo.countryOfResidence || ''
            let nationality =
                this.$store.state.registration.form.basicInfo.nationality || ''
                 let CountryResidentTitle =
                this.$store.state.registration.form.fatcaInfo.CountryResidentTitle || ''
            let CountryTaxTitle =
                this.$store.state.registration.form.fatcaInfo.CountryTaxTitle || ''
            let dualNationalCountryTitle =
                this.$store.state.registration.form.fatcaInfo.dualNationalCountryTitle || ''
            let countriesWithoutCRS = ['Pakistan', 'United States of America','']
             console.log(countryOfResidence, nationality)
            if (
                countriesWithoutCRS.includes(countryOfResidence) &&
                countriesWithoutCRS.includes(nationality) &&
                countriesWithoutCRS.includes(CountryResidentTitle) &&
                countriesWithoutCRS.includes(CountryTaxTitle) &&
                countriesWithoutCRS.includes(dualNationalCountryTitle)
            ) {
                const idx = this.fields.reduce((a, field, index) => {
                    if (
                        field.key == 'crsInfo.crsCountryTax1' ||
                        field.key == 'crsInfo.crsTIN1' ||
                        field.key == 'crsInfo.crsReason1' ||
                        field.key == 'crsInfo.crsOtherReason1' ||
                        field.key == 'crsInfo.crsCountryTax2' ||
                        field.key == 'crsInfo.crsTIN2' ||
                        field.key == 'crsInfo.crsReason2' ||
                        field.key == 'crsInfo.crsOtherReason2' ||
                        field.key == 'crsInfo.crsCountryTax3' ||
                        field.key == 'crsInfo.crsTIN3' ||
                        field.key == 'crsInfo.crsReason3' ||
                        field.key == 'crsInfo.crsOtherReason3' ||
                        field.label ==
                            'CRS Form for Tax Residency Self Certification'
                    )
                        a.push(index)
                    return a
                }, [])
                this.CRSFormFields = []
                for (var i = 0; i < idx.length; i++) {
                    this.CRSFormFields.push(this.fields[idx[i]])
                }

                this.fields.splice(idx[0], idx.length)
                } else {
                console.log("showing CRS form")
                this.showCRSForm()
            }
        },      
        registrationW9WatchKey(form) {
            const f = form.fatcaInfo || {}
            return [
                f.isUSCitizen,
                f.isUSResident,
                f.greenCardUS,
                f.countryOfResidence,
                f.CountryResidentTitle,
                f.CountryTaxTitle,
                f.dualNationalCountryTitle,
            ].join('|')
        },
        registrationCRSWatchKey(form) {
            const f = form.fatcaInfo || {}
            return [
                f.countryOfResidence,
                f.CountryResidentTitle,
                f.CountryTaxTitle,
                f.dualNationalCountryTitle,
            ].join('|')
        },
         applyCountryOfResidenceFromSetupProfileToKyc() {
            const basic = this.$store.state.registration.form.basicInfo
             const contact = this.$store.state.registration.form.contactInfo

            const id = basic.countryOfResidenceId
            const title = basic.countryOfResidence
            const usResident = contact.residentUS
            const usGreenCard = contact.greenCardUS
            if (!id && !title && !usResident && !usGreenCard) {
                return
            }
            if(usResident) {
                 this.$store.commit('updateField', {
                    key: 'fatcaInfo.isUSResident',
                    value: usResident,
                })
            }
            if(usGreenCard) {
                 this.$store.commit('updateField', {
                    key: 'fatcaInfo.greenCardUS',
                    value: usGreenCard,
                })
            }
            if (id) {
                this.$store.commit('updateField', {
                    key: 'fatcaInfo.countryOfResidenceId',
                    value: id,
                })
                this.$store.commit('updateField', {
                    key: 'crsInfo.crsCountryTax1',
                    value: id,
                })
            }
            if (title) {
                this.$store.commit('updateField', {
                    key: 'fatcaInfo.countryOfResidence',
                    value: title,
                })
                this.$store.commit('updateField', {
                    key: 'crsInfo.crsCountryTaxTitle1',
                    value: title,
                })
            }
            const lockKeys = new Set([
                'fatcaInfo.countryOfResidenceId',
                'crsInfo.crsCountryTax1',
                
                
            ])
            this.fields.forEach((field) => {
                if (lockKeys.has(field.key)) {
                    this.$set(field, 'isDisabled', true)
                }
            })
        },
        async onSave() {
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                this.$store.commit('updateField', {
                    key: 'forms.form4.valid',
                    value: true,
                })
                let registrationUrl = '/customers/update-individual-customer'
                this.$store.commit('setLoading', true)

                try {
                    const formData = this.$store.state.registration.form
                    // formData.dataSegmentId = this.dataSegmentId

                    const { data } = await request({
                        url: registrationUrl,
                        method: 'post',
                        data: formData,
                    })

                    this.$toasted.show('Changes saved successfully', {
                        duration: 3000,
                        type: ['success'],
                    })

                    this.$store.commit('setLoading', false)
                } catch (errors) {
                    this.$store.commit('setError', errors)
                    this.$store.commit('setLoading', false)
                }
            } else {
                this.$store.commit('updateField', {
                    key: 'forms.form4.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
            }

            // }
        },
        onBack() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-setup-profile-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/register-customer/setup-profile')
            }
        },
    }, // End of Component > watch
} // End of export default
</script>